import { nonUndefined } from "Utility";
import { RoundTime } from "model/Match/Track/RoundTime";
import { FsRoundTime } from "db/model/match/Track/FsRoundTime";

export const mapRoundTimes = (fsModels: FsRoundTime[]) => {
  return nonUndefined(fsModels.map(mapRoundTime));
};

const mapRoundTime = (fsModel: FsRoundTime): RoundTime | undefined => {
  if (!fsModel.id || !fsModel.pos) {
    return undefined;
  }

  return {
    driverId: fsModel.id,
    finishTimeMs: fsModel.time,
    position: fsModel.pos,
  };
};
